var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-modal',{attrs:{"show":_vm.showVideo,"type":"tag","title":"视频播放"},on:{"close":function($event){_vm.showVideo = false}}})
}
var staticRenderFns = []

export { render, staticRenderFns }